import styled from "styled-components";
import { Constants } from "@tiffin/app-common";
import { Button, Divider, Form, Input, Modal, Select } from "antd";

export const GuestDetailsModal = styled(BaseGuestDetailsModal)`
  .ant-form-item {
    margin: 12px 0;

    input {
      padding: 8px 12px;
      font-size: small;
    }
  }

  .phone-number {
    input.ant-input {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }

  .save-details {
    padding: 5px 0;
    display: flex;
    justify-content: flex-end;
  }
`

interface IGuestDetailsModal {
  className?: string
  handleUpdate: (values: any) => void,
  isOpen: boolean,
  onCancel: () => void
}

const { Option } = Select

function BaseGuestDetailsModal({className, handleUpdate, isOpen, onCancel}: IGuestDetailsModal) {

  const prefixSelector = (
    <Form.Item name="phonePrefix" noStyle initialValue={"61"}>
      <Select disabled style={{ width: 70 }}>
        <Option value={"61"}>+61</Option>
      </Select>
    </Form.Item>
  )

  return (
    <Modal
      className={className}
      open={isOpen}
      title="Your details"
      onCancel={onCancel}
      footer={[]}
    >
      <Divider />
      <Form
        name="edit-account"
        initialValues={{
          prefix: "61",
        }}
        layout="vertical"
        onFinish={(values: any) => handleUpdate(values)}
        onFinishFailed={(err) => console.error(err)}
      >
        <Form.Item
          label="Mobile number"
          name="phone"
          rules={[
            {
              required: true,
              message: Constants.ERRORMESSAGE_ENTERPHONENUMBER,
            },
            () => ({
              validator(_, value: string) {
                if (value && value.length === 0) {
                  return
                }
                if (value && !isNaN(Number(value))) {
                  if (value.length === 9 || (value.length === 10 && value.startsWith("0"))) {
                    return Promise.resolve()
                  }
                  return Promise.reject(new Error(Constants.ERRORMESSAGE_INVALIDPHONENUMBER))
                }
                if (typeof value === "undefined") {
                  //No need to send error if undefined as it is a required field
                  return Promise.resolve()
                }
                return Promise.reject(new Error(Constants.ERRORMESSAGE_INVALIDPHONENUMBER))
              },
            }),
          ]}
        >
          <Input className="phone-number" addonBefore={prefixSelector} placeholder="Mobile number" />
        </Form.Item>
        <Form.Item
          label="First Name"
          name="firstName"
          rules={[
            {
              required: true,
              message: Constants.ERRORMESSAGE_ENTERFIRSTNAME,
            },
          ]}
        >
          <Input placeholder="First Name" />
        </Form.Item>
        <Form.Item
          label="Last Name"
          name="lastName"
          rules={[
            {
              required: true,
              message: Constants.ERRORMESSAGE_ENTERLASTNAME,
            },
          ]}
        >
          <Input placeholder="Last Name" />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              type: "email",
              message: Constants.ERRORMESSAGE_INVALIDEMAIL,
            },
            {
              required: true,
              message: Constants.ERRORMESSAGE_ENTEREMAIL,
            },
          ]}
        >
          <Input placeholder="Email" type="email" />
        </Form.Item>
        <div className="save-details">
          <Button type="primary" htmlType="submit">
            Update
          </Button>
        </div>
      </Form>
    </Modal>
  )
}